import React from 'react';
import { Route } from '../Routing/types';
import { AchievementsPage } from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/achievements',
    element: <AchievementsPage />,
    private: true,
    title: dummy_t('allAchievements.navbarTitle'),
    mobileAppTabIdentifier: 'profile',
  },
];

export default routes;
